import { useState } from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { InputLabel } from "@mui/material";
import { ErrorMessage, Field, FormikProps, FormikValues, getIn, useFormikContext } from "formik";

const marks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 8,
    label: "8",
  },
  {
    value: 10,
    label: "10",
  },
];

function valuetext(value: number) {
  return `${value}`;
}

export default function PrioritySlider(props: any) {
  const { label, name, disabled } = props;
  const formik: FormikProps<FormikValues> = useFormikContext();
  const [sliderValue, setSliderValue] = useState(formik?.values?.Priority || 5);

  const handleChange = (event: Event, newValue: number | number[]) => {
    setSliderValue(newValue);
    formik.setFieldValue(name, newValue);
  };

  const PrettoSlider = {
    color: sliderValue < 5 ? "#52af77" : sliderValue < 9 ? "#FFD54F" : "red",
    height: 8,
    "& .MuiSlider-track": {
      border: "none",
    },
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
        boxShadow: "inherit",
      },
      "&:before": {
        display: "none",
      },
    },
    "& .MuiSlider-valueLabel": {
      lineHeight: 1.2,
      fontSize: 12,
      background: "unset",
      padding: 0,
      width: 32,
      height: 32,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: sliderValue < 5 ? "#52af77" : sliderValue < 9 ? "#FFD54F" : "red",
      transformOrigin: "bottom left",
      transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
      "&:before": { display: "none" },
      "&.MuiSlider-valueLabelOpen": {
        transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
      },
      "& > *": {
        transform: "rotate(45deg)",
      },
    },
  };

  return (
    <Box sx={{ width: "100%" }}>
      <InputLabel htmlFor={`priority-slider-${sliderValue}`}>{label}</InputLabel>
      <Field
        as={Slider}
        id={`priority-slider-${sliderValue}`}
        name={name}
        value={sliderValue}
        onChange={handleChange}
        getAriaValueText={valuetext}
        style={PrettoSlider}
        step={1}
        marks={marks}
        valueLabelDisplay="auto"
        min={0}
        max={10}
        color="secondary"
        helperText={<ErrorMessage name={name} />}
        error={getIn(formik.touched, name) && getIn(formik.errors, name)}
        disabled={disabled}
      />
    </Box>
  );
}
